define([
], function (
    ) {
    function convertContentTypeToIconClass (contentType) {
        /*
         *  HTML の class 名に変換するため、content type (MIME タイプ) 文字列に
         *  含まれている '/' , '.' , '+' を '-' に変換する
         *  e.g.) （変換前）application/vnd.mspowerpoint ->（変換後）application-vnd-mspowerpoint
         */
        return contentType ? contentType.replace(/\/|\.|\+/g, '-') : null;
    }

    return convertContentTypeToIconClass;
});



// WEBPACK FOOTER //
// ./common/ui/template/helper/content-type-to-icon-class.js